import type { FaireProductEntity } from "../../entity_types/product";

export const driftless_studios_15: FaireProductEntity = {
  token: "driftless-studios-15",
  type: "product",
  name: "Glad to Live in a World with Octobers Fall Pillow Cover",
  brandName: "Driftless Studios",
  imageUrl:
    "https://cdn.faire.com/fastly/e8d478576f40a1f5e6ff7c891d860ba4d3fe0e00869abdb918a0563bb777a2d9.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=960&width=720",
  priceDollars: 18.5,
  msrpDollars: 32,
  freeShipping: true,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_proto_home-and-living"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
